import SettingsTooltip from './settings-tooltip';

export default SettingsTooltip;
